<template>
  <div class="loader-container">
    <div class="catalog-product-item" :class="{ retrofit: product.Retrofit }">
      <router-link tabindex="0"
        :to="{
          name: productUrl,
          params: {
            product: product.Id,
          },
          query: {
            hotspots: product.GrafikId,
            vehicleSpecific: product.VehicleSpecific,
          },
        }"
        class="product-item"
      >
        <div v-if="product.PictureUrl" class="product-item__img">
          <img :src="pictureUrlPath(product.PictureUrl)" />
        </div>
        <div class="retrofit-text m-t-10" v-if="product.Retrofit">{{ $t('Retrofit') }}</div>
        <SfHeading
          class="product-item__title"
          :title="product.Name"
          :description="product.Sku"
          :level="4"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import { SfHeading } from '@storefront-ui/vue';
import { config } from '@/modules/core';

export default {
  name: 'ProductListItem',
  mixins: [config],
  components: {
    SfHeading,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    productUrl: {
      type: String,
      default: 'Product',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.catalog-product-item {
  max-width: 216px;
  padding: var(--spacer-xs);
  margin: 0 auto var(--spacer-xl) auto;
  text-align: center;
  @include flexbox-desktop {
    opacity: 0.9;
    &:hover {
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      opacity: 1;
    }
  }
}

.retrofit-text {
  color: var(--c-danger);
}

.product-item {
  @include font(
    --product-card-title-font,
    var(--font-medium),
    var(--font-sm),
    1.2,
    var(--font-family-secondary)
  );
  text-decoration: none;
  &__img img {
    width: 100%;
  }
  &__title {
    color: var(--c-dark);
    margin-top: var(--spacer-sm);
  }
  &__price {
    cursor: text;
  }
}
</style>
